import { type CellContext } from "@tanstack/react-table";

interface TableCellProps<TData> {
  cell: CellContext<TData, unknown>;
  value?: string | number;
}

export const CellTextFormatter = <TData,>(props: TableCellProps<TData>) => {
  return (
    <div
      className="px-4 py-2.5 h-full bg-inherit text-v2-primary font-mono text-xs flex items-center gap-3"
      title={String(props.cell.getValue())}
    >
      {props.value ? props.value : String(props.cell.getValue())}
    </div>
  );
};
